import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../Banner';
import useBanners from '../Banner/useBanners.hooks';
import Colors from '../../utils/color';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  innerCard: {
    margin: spacing(1.5, 1.5, 0, 1.5),
    padding: spacing(1.5),
    backgroundColor: '#F5F9FD',
    border: `${spacing(0.125)} solid ${Colors.alto}`,
    borderRadius: spacing(1),
  },
}));

/**
 * BannerCard — top section of the center card: an inner card that shows the
 * Banner's time-period category notifications (without the EXPAND/CLOSE
 * button). Hidden entirely when there are no banners.
 */
const BannerCard = () => {
  const classes = useStyles();
  const banners = useBanners();

  if (!banners.length) {
    return null;
  }

  return (
    <div className={classes.innerCard}>
      <Banner embedded />
    </div>
  );
};

export default BannerCard;
